import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';
import { registerSteps } from '../../constants';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { Divider } from '@/components/Divider';
import { useRegisterApi } from '../../hooks';
import { TRedirectData } from '../../types';

interface IAccountInvalidShahkarBottomsheetProps {
  handleRegisterLogic: (__data: TRedirectData) => void;
  currentStepPayload: TRedirectData;
}

const AccountInvalidShahkarBottomsheet: FC<
  IAccountInvalidShahkarBottomsheetProps
> = ({ currentStepPayload, handleRegisterLogic }) => {
  const { mutateAsync: submitContinueWithInvalidShahkarNumber, isLoading } =
    useRegisterApi('continueWithInvalidShahkarNumber', {
      isMutation: true,
    });

  const handleCtaAction = (shouldEditPhone: boolean) => {
    const redirectData = {
      requestToken: currentStepPayload?.requestToken,
    } as unknown as TRedirectData;

    if (shouldEditPhone) {
      redirectData.nextStep = registerSteps?.MofidOtp;
      handleRegisterLogic(redirectData);
      BottomSheet.close();
    } else {
      submitContinueWithInvalidShahkarNumber({
        requestToken: currentStepPayload.requestToken,
      })
        .then((res) => {
          redirectData.nextStep = res?.nextStep;
          redirectData.message = res?.message;
          redirectData.invalidState = !!res?.invalidState;
          handleRegisterLogic(redirectData);
        })
        .finally(() => {
          BottomSheet.close();
        });
    }
  };

  return (
    <div className="flex flex-col gap-y-6">
      <Text color="gray-120" size="sm" weight="regular">
        {currentStepPayload?.message?.message}
      </Text>
      <Divider />
      <div className="flex flex-col gap-y-2 md:flex-row md:gap-x-2">
        <Button
          analytics={['NEW_REG_DUPLICATE_PHONE_EDIT']}
          className="w-full md:w-1/2"
          disabled={isLoading}
          onClick={() => handleCtaAction(true)}
        >
          ویرایش شماره موبایل
        </Button>
        <Button
          analytics={['NEW_REG_DUPLICATE_PHONE_CONTINUE']}
          className="w-full md:w-1/2"
          isLoading={isLoading}
          variant="link"
          onClick={() => handleCtaAction(false)}
        >
          با همین شماره موبایل ادامه می‌دهم
        </Button>
      </div>
    </div>
  );
};

export const openAccountInvalidShahkarBottomsheet = (
  currentStepPayload: TRedirectData,
  handleRegisterLogic: (__data: TRedirectData) => void
) => {
  return BottomSheet.open({
    children: (
      <AccountInvalidShahkarBottomsheet
        currentStepPayload={currentStepPayload}
        handleRegisterLogic={handleRegisterLogic}
      />
    ),
    closeAction: () => {},
  });
};
